import React, { ComponentType } from 'react';

/**
 * A workaround for React.memo. Read more at: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const typedMemo: <T extends ComponentType<any>>(
    c: T,
    areEqual?: (prev: React.ComponentProps<T>, next: React.ComponentProps<T>) => boolean
) => T = React.memo;
